<!--
 * @Description: 用户关系新增和编辑所用的对话框组件
 * @Author: gaohc
 * @Date: 2021-04-01 09:09:02
 * @LastEditTime: 2022-04-04 15:02:28
-->

<template>
  <el-dialog width="640px" :title="dialogTitle" :visible.sync="visible" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" center>
    <el-form class="form" ref="usershipForm" :model="usershipForm" :rules="rules" label-width="120px">
      <el-form-item label="名称" prop="name">
        <el-input size="small" clearable v-model="usershipForm.name"  placeholder="请输入关系名称" maxlength="5" autocomplete="off" style="width: 320px"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('usershipForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: "UsershipDialog",
  props: ["visible", "operate", "usershipId"],
  data() {
    return {
      usershipForm: {},
      rules: {
        name: [{ required: true, message: "请输入关系名称", trigger: "blur" }],
      },
    };
  },

  computed: {
    dialogTitle() {
      return this.operate == "add" ? "新增用户关系" : "编辑用户关系";
    },
  },

  methods: {
    initData() {
      this.clearVaild();
      if (this.operate == "edit") {
        let params = {id: this.usershipId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_USERSHIPCFG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.usershipForm = result.data;
          }
        });
      }
    },

    clearData() {
      this.usershipForm = {};
    },

    clearVaild() {
	this.$nextTick(() => {
        this.$refs["usershipForm"].clearValidate();
      });
    },

    handleSubmit(usershipForm) {
      this.$refs[usershipForm].validate((valid) => {
        if (!valid) return false;

        let url = this.operate == "add" ? Constant.URL_SAVE_USERSHIPCFG : Constant.URL_UPDATE_USERSHIPCFG;
        let method = (this.operate == 'add') ? 'POST' : 'PUT';
        let header = this.encryptionUtil.signatureBody(this.usershipForm,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: this.usershipForm,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.clearData();
            this.$emit("close-dialog", true);
          }
        });
      });
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/syscfg/components/usercfg/UsershipDialog.vue